import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Marché DZ';
const DEFAULT_DESCRIPTION = 'Marché DZ - أكبر سوق إلكتروني في الجزائر. تسوق أونلاين بأفضل الأسعار: ملابس، إلكترونيات، هواتف، خدمات، مطاعم، وتوصيل سريع إلى جميع الولايات.';
const DEFAULT_IMAGE = '/icons/icon-512.png';
const SITE_URL = 'https://www.xn--marchdz-fya.com';

interface SEOHeadProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article' | 'product';
  noindex?: boolean;
  keywords?: string;
  canonical?: string;
  jsonLd?: Record<string, any> | Record<string, any>[];
}

const SEOHead = ({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  noindex = false,
  keywords,
  canonical,
  jsonLd,
}: SEOHeadProps) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - سوق إلكتروني في الجزائر`;
  const fullUrl = url ? `${SITE_URL}${url}` : SITE_URL;
  const fullImage = image.startsWith('http') ? image : `${SITE_URL}${image}`;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : fullUrl;

  const defaultKeywords = 'سوق إلكتروني الجزائر, تسوق أونلاين, شراء عبر الإنترنت, marketplace algérie, boutique en ligne algérie, marché dz, ملابس, إلكترونيات, هواتف, أحذية, مطاعم, خدمات, توصيل';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <link rel="canonical" href={canonicalUrl} />

      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {!noindex && <meta name="robots" content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="ar_DZ" />
      <meta property="og:locale:alternate" content="fr_DZ" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(jsonLd) ? jsonLd : jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
